/**
 * Single owner of the client Firebase app, Firestore, and Auth instances.
 *
 * Every module that needs Firestore must import `db` from here rather than
 * calling `getFirestore()` itself — a bare `getFirestore()` returns the
 * app's (default) database, which is the wrong (US) database in production.
 * Pinning the database id in one place keeps all reads/writes on the same DB
 * (prod → madameai-canada, dev/local → (default)).
 *
 * This module also exists to break the firebase.js ⇄ levelManager.js import
 * relationship: both can import `db` from here without depending on each other.
 */
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { _config } from '../Constants';

export const app = initializeApp(_config.firebase);
// getFirestore(app, '(default)') is equivalent to getFirestore(app).
export const db = getFirestore(app, _config.firestoreDatabaseId || '(default)');
export const auth = getAuth(app);
